import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.24 5.75L11.66 7.17114L7.85 10.9942H20V13.0058H7.85L11.66 16.8289L10.24 18.25L4 12.005L10.24 5.75Z" fill={ fill || 'currentColor' } />
    </svg>
);
